import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { BarraTituloComponent } from './barra-titulo/barra-titulo.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule
    ],
    declarations: [
        SidebarComponent,
        HeaderComponent,
        FooterComponent,
        BarraTituloComponent,
        SpinnerComponent,
    ],
    exports: [
        SidebarComponent,
        HeaderComponent,
        FooterComponent,
        BarraTituloComponent,
        SpinnerComponent
    ]
})
export class SharedModule { }